module.exports = __webpack_public_path__ + "assets/img/back.b4bbd287.png";